// extracted by mini-css-extract-plugin
export default {"codeRow":"DiscountFormModal_codeRow__e8DkM","codeInput":"DiscountFormModal_codeInput__gi3Wc","modalBody":"DiscountFormModal_modalBody__MGGIf"};